import axios from "axios"
import tools from "./tools.js"
import { showToast , showDialog } from 'vant'
import Router from '../router'

// if (process.env.VUE_APP_BASE_API != "http://localhost:5084") {

//   axios.get('/config.json?id=' + new Date()).then((res) => {
//     localStorage.setItem("ajax-url", res.data.baseUrl);
//     console.log("访问路径已加载:" + res.data.baseUrl)

//     axios.defaults.withCredentials = true;
//     axios.defaults.baseURL = localStorage.getItem("ajax-url");//process.env.VUE_APP_BASE_API;
//   })
// } else {
//   axios.defaults.withCredentials = true;
//   axios.defaults.baseURL = "http://localhost:5084";//process.env.VUE_APP_BASE_API;
//   console.log("访问路径已加载为本地")
// }

// sessionStorage.setItem("BASEURL",window.envs.ApiUrl);
// sessionStorage.setItem("Title",window.envs.Title);
// sessionStorage.setItem("Title",window.envs.Icon);

// axios.defaults.withCredentials = true;
// axios.defaults.baseURL = localStorage.getItem("ApiUrl"); // process.env.VUE_APP_BASE_API;

// 请求拦截器
axios.interceptors.request.use(function (config) {
  config.headers["Authorization"] = localStorage.getItem("Authentication_Header")
  config.headers["LanguageId"] = localStorage.getItem("LanguageOpt")
  config.headers["SecurityCode"] = localStorage.getItem("System.ScanQrCodes.SecurityCode")

  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  if (response.data.Code == 401) {
    tools.DialogConfirm("需要登录", "这个操作需要登录，请登录", () => {
      // 跳转登录
      Router.push({
        name: "login"
      })
    })
  } else if (response.data.Code == 422) {
    // 字段验证错误
    var html = ""
    response.data.FullMsg.forEach((e) => {
      html += "<p>" + e + "</p>"
    })
     
    showToast({
      type: "html",
      message: html
    })
    return
  }else if (response.data.Code == 455) {
    localStorage.setItem('useSecurityCode', this.HomeConfigs.useSecurityCode ? "yes" : "no")
  }
  return response
}, function (error) {
  // 对响应错误做点什么
  return Promise.reject(error)
})

const AXIOS = {
  // 纯属调取接口
  apiMethod (action, method, param, success, error) {
    try {
      param = param == null ? {} : param

      if (method == "post" || method == "put" || method == "patch") {
        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("Authentication_Header"),
            LanguageId: localStorage.getItem("LanguageOpt"),
            "Access-Control-Allow-Origin": "*"
          }
        }

        console.log(sessionStorage.getItem("ApiUrl")+ action)
        axios.post(sessionStorage.getItem("ApiUrl") + action, param, { headers: config })
          .then(function (response) {
            if (response) { success(response.data) }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        const config = {
          Authorization: localStorage.getItem("Authentication_Header"),
          LanguageId: localStorage.getItem("LanguageOpt")
        }
        console.log("get:" + sessionStorage.getItem("ApiUrl")+ action)
        axios.get(sessionStorage.getItem("ApiUrl") + action, { params: param, headers: config })
          .then(function (response) {
            if (success) {
              success(response.data)
            }
          })
      }
    } catch (e) {
      alert(666)
      alert(e)
    }
  }, GetUrl () {
    return sessionStorage.getItem("ApiUrl")
    // return   process.env.VUE_APP_BASE_API;
  }, ToLogin () {
    showDialog.confirm({
      title: '提示',
      message:
        '需要进行登录,是否跳转?'
    })
      .then(() => {
        Router.push({
          name: "shoppinglogin"
        })
      })
      .catch(() => {
        // on cancel
      })
 
  }
}
export default AXIOS
 